import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { User } from '../../models/user';
import { ConfigService } from '../config/config.service';
import { UtilityService } from '../utility/utility.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  usersEndpoint = this.config.adminDashboardApiUrl + '/Users';

  getUserByExternalId(externalId: string): Observable<User> {
    const url = this.usersEndpoint + '?externalId=' + externalId;
    return this.utilityService.getRequest<User>(url);
  }

  getOrInsertUser(user: User): Observable<User> {
    return this.utilityService.postRequest<User>(this.usersEndpoint, user);
  }
}
